import React from 'react';
import { useSelector } from 'react-redux';
import {
  Collapse,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import SearchTopBar from '../SearchTopBar';
import ListData from '../ListData';
import { fetchVendor } from '../../../../redux/actions/expensesActions';

const Proveedor = ({
  type,
  fetchData,
}) => {
  React.useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const proveedores = useSelector(state => state.gastos.proveedores);
  const loads = useSelector(state => state.loads);
  return (
    <div>
      <SearchTopBar type={type} />
      { loads.updateIsLoading && (
        <Collapse in={loads.updateIsLoading}>
          <LinearProgress />
        </Collapse>
      )}
      { !loads.updateIsLoading && proveedores.data.length === 0 && (
        <Collapse in={!loads.updateIsLoading && proveedores.data.length === 0}>
          <List dense>
            <ListItem classes={{ root: 'bg-white' }}>
              <ListItemText
                primary="Sin proveedores"
                secondary="No cuenta con proveedores"
              />
            </ListItem>
          </List>
        </Collapse>
      )}
      { !loads.updateIsLoading && proveedores.data.length > 0 && (
        <Collapse in={!loads.updateIsLoading && proveedores.data.length > 0}>
          <ListData data={proveedores.data} fetchData={fetchVendor} type={type} />
        </Collapse>
      )}
    </div>
  );
};

export default Proveedor;
